<template>
<!-- eslint-disable max-len -->
<list-page
  name="Minor Decision"
  use="_id"
  :display="display"
  page-prefix="/blade/minor-decisions"
  :fetch="getIndividualDecisions"
  :remove="deleteIndividualDecision"
></list-page>
</template>

<script>
import { mapActions } from 'vuex';

import ListPage from '../../ui/pages/ListPage';

export default {
  components: {
    ListPage
  },
  methods: {
    ...mapActions([
      'getIndividualDecisions',
      'deleteIndividualDecision'
    ]),
    display({ name: individualDecisionName, updated }) {
      const date = updated && new Date(updated);
      const dateString = date && `(edited ${date.toLocaleDateString()} ${date.toLocaleTimeString()})` || '';
      return `${individualDecisionName} ${dateString}`;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/IndividualDecisionsList.vue